module.exports = __webpack_public_path__ + "img/cocio_logo.6452c10c.svg";